import { GetAllGGNotificationMemberDTO, GetAllGGNotificationMemberFiltersDTO, GGNotificationMemberDTO } from "./dto";
import { GGNotificationMemberServiceImpl } from "./serviceImpl";

export interface GGNotificationMemberService {
    CreateGGNotificationMember(data: GGNotificationMemberDTO): Promise<void>
    DeleteGGNotificationMember(id: string): Promise<void>
    GetAllGGNotificationMember(filters: GetAllGGNotificationMemberFiltersDTO): Promise<GetAllGGNotificationMemberDTO>
    GetGGNotificationMemberById(id: string): Promise<GGNotificationMemberDTO>
}

export function NewGGNotificationMemberService(): GGNotificationMemberService {
    return new GGNotificationMemberServiceImpl()
}